import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HelpModalComponent } from './components/help-modal/help-modal.component';
import { ImagePreviewOverlayComponent } from './components/image-preview-overlay/image-preview-overlay.component';
import { FcmService } from './services/fcm.service';
import { SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HelpModalComponent, ImagePreviewOverlayComponent],
  template: `
    <router-outlet />
    <app-help-modal />
    <app-image-preview-overlay />
  `
})
export class AppComponent implements OnInit {
  private readonly fcm = inject(FcmService);
  private readonly seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.init();
    void this.fcm.init();
  }
}
